<script>

import { Overlay } from '../../'
import {drawIndicatorPlot} from '../../workspace/indicator-plots.mjs'

export default {
    name: 'SuperTrend',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'SuperTrend - Trend following indicator based on ATR',
                preset: {
                    name: 'SuperTrend $atr_length $multiplier',
                    side: 'onchart',
                    settings: {
                        lineWidth: 1,
                        color: '#ff5722'
                    }
                }
            }
        },
        draw(ctx){
            const settings=this.settings,layout=this.layout,plot=settings.$plotConfig?.outputs?.[0]||{};
            if(plot.visible===false)return;
            const candles=new Map((this.sub||[]).map(row=>[row[0],row]));
            if(settings.showTrendFill!==false){
                ctx.save();ctx.globalAlpha=(settings.opacity??100)/100*.1;
                for(let index=1;index<this.data.length;index++){
                    const a=this.data[index-1],b=this.data[index],ca=candles.get(a[0]),cb=candles.get(b[0]);
                    if(!ca||!cb)continue;
                    for(const [column,color,show] of [[2,settings.upColor||'#26a69a',settings.showUpTrend],[3,settings.downColor||'#ef5350',settings.showDownTrend]]){
                        if(show===false||!Number.isFinite(a[column])||!Number.isFinite(b[column]))continue;
                        ctx.fillStyle=color;ctx.beginPath();ctx.moveTo(layout.t2screen(a[0]),layout.$2screen((ca[1]+ca[4])/2));ctx.lineTo(layout.t2screen(b[0]),layout.$2screen((cb[1]+cb[4])/2));ctx.lineTo(layout.t2screen(b[0]),layout.$2screen(b[column]));ctx.lineTo(layout.t2screen(a[0]),layout.$2screen(a[column]));ctx.fill();
                    }
                }
                ctx.restore();
            }
            for(const [column,color,show] of [[2,settings.upColor||'#26a69a',settings.showUpTrend],[3,settings.downColor||'#ef5350',settings.showDownTrend]]){
                if(show===false)continue;
                const styled={...settings,$plotConfig:{...settings.$plotConfig,outputs:[{...plot,color}]}};
                drawIndicatorPlot(ctx,this.data.map(row=>[row[0],row[column]]),layout,styled,0,{color});
            }
        },
        legend(values){return [{value:values[1],color:Number.isFinite(values[2])?(this.settings.upColor||'#26a69a'):(this.settings.downColor||'#ef5350')}]},
        use_for() { return ['SuperTrend'] },
        calc() {
            return {
                props: {
                    atr_length: { def: 10, text: 'ATR Length' },
                    multiplier: { def: 3, text: 'Multiplier' }
                },
                conf: { renderer: 'Spline' },
                update: `
                    let [st, trend] = supertrend(multiplier, atr_length)
                    return st[0]
                `
            }
        }
    }
}
</script>
